var React = require('react');

function BlobIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M109.219 40.9906C114.594 60.6776 107.394 80.9705 93.0947 91.3693C78.7954 101.667 57.1943 101.97 36.4045 89.653C15.6147 77.3359 -4.56658 52.399 0.909753 32.6109C6.38609 12.8229 37.3172 -1.91715 61.7579 0.202991C86.0971 2.32314 103.946 21.3035 109.219 40.9906Z","fill":"#DEF2EB"}));
}

BlobIcon.defaultProps = {"width":"111","height":"99","viewBox":"0 0 111 99","fill":"none"};

module.exports = BlobIcon;

BlobIcon.default = BlobIcon;
